export { useRatingBase_unstable as useRating } from '@fluentui/react-rating';
